/** Shared palette tokens (light UI accents; primary/secondary live in MUI theme). */
export const BRAND = {
  peachTint: "#FFE5D9",
  navy: "#0D2B67",
  danger: "#CB2D1B",
  green: "#22C55E",
  orange: "#FF6B00",
} as const;

export const DEFAULT_CURRENCY = "EUR";

/** Stat cards on home and reports (icon circle fill and icon color). */
export const STAT_ACCENTS = {
  expenses: { color: BRAND.danger },
  gains: { color: BRAND.green },
  net: { color: BRAND.navy },
  entries: { color: BRAND.navy },
  categories: { color: "#3B82F6" },
} as const;

/** Pie / chart fills (repeated slice palette). */
export const REPORT_CHART_COLORS = [
  BRAND.navy,
  BRAND.orange,
  "#3B82F6",
  "#10B981",
  "#8B5CF6",
  "#EF4444",
  "#F59E0B",
] as const;
